"use client";

import { PROMOTION_AIRLINE } from "@/components/booking/Result";
import { toast } from "react-toastify";
import ProgressIcon from "@/components/icons/ProgressIcon";
import SuccessIconV2 from "@/components/icons/SuccessIconV2";
import WaitIcon from "@/components/icons/WaitIcon";
import VietnamIcon from "@/components/icons/VietnameIcon";
import Text from "@/components/common/Typography/Text";
import { TypeSegment } from "@/lib/redux/features/flight/type";
import { useAppSelector } from "@/lib/redux/hooks";
import { parseJson } from "@/utils/safeParse/parseJson";
import { Col, Row, Select, Steps } from "antd";
import { useTranslation } from "react-i18next";
import { usePathname } from "next/navigation";
import dayjs from "dayjs";
import { useAppDispatch } from "@/lib/redux/hooks";
import { thunks } from "@/lib/redux/thunks";
import { useTERouter } from "@/hooks/app/useTERouter";
import Link from "next/link";

const BookingProgresses = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const pathname = usePathname();
  const router = useTERouter();
  const step_booking = useAppSelector((state) => state.booking.step_booking);
  const orderDetail = useAppSelector(
    (state) => state.booking.order_detail?.data,
  );
  const isFlight = orderDetail?.productType === "FLIGHT";
  const itinData = parseJson(orderDetail?.itinData) || [];

  const isPromotion = isFlight
    ? orderDetail?.isVJPromotion &&
      itinData?.some(
        (segment: TypeSegment) => segment.airline === PROMOTION_AIRLINE,
      )
    : false;
  const isFlightPromotionAndSucceed =
    isFlight &&
    isPromotion &&
    orderDetail?.paymentStatus === "PAID" &&
    (orderDetail?.bookingStatus === "ACTIVE" ||
      orderDetail?.bookingStatus === "HOLD");

  const changeLanguage = async (language: "vi" | "en") => {
    if (language === "en") {
      try {
        await dispatch(thunks.get_exchange_currency({})).unwrap();
      } catch {
        toast.error(t("common.exchange_currency_failed"));
        return;
      }
    }
    dayjs.locale(language);
    router.push(
      pathname
        .replace("/vi/", `/${language}/`)
        .replace("/en/", `/${language}/`)
        .replace("/vi", `/${language}`)
        .replace("/en", `/${language}`),
    );
    i18n.changeLanguage(language);
  };

  return (
    <Row align="middle" justify="center" wrap={false} style={{ width: "100%" }}>
      <Steps
        style={{ flex: 1, minWidth: 0 }}
        items={[
          {
            title: t("booking.pass_info"),
            status: "process",
            icon:
              step_booking === "passenger_info" ? (
                <ProgressIcon style={{ fontSize: "3.2rem" }} />
              ) : (
                <SuccessIconV2 style={{ fontSize: "2.7rem" }} />
              ),
          },
          {
            title: t("common.payment"),
            status: "process",
            icon:
              step_booking === "payment" ? (
                <ProgressIcon style={{ fontSize: "3.2rem" }} />
              ) : step_booking === "result" ? (
                <SuccessIconV2 style={{ fontSize: "2.7rem" }} />
              ) : (
                <WaitIcon style={{ fontSize: "2.7rem" }} />
              ),
          },
          {
            title: t("booking.ticket_deli"),
            status: "process",
            icon:
              step_booking === "result" ? (
                `${
                  isFlightPromotionAndSucceed ||
                  isPromotion ||
                  orderDetail?.orderStatus
                }_${orderDetail?.paymentStatus}_${orderDetail?.bookingStatus}` ===
                "CONFIRM_PAID_ACTIVE" ? (
                  <SuccessIconV2 style={{ fontSize: "2.7rem" }} />
                ) : (
                  <ProgressIcon style={{ fontSize: "3.2rem" }} />
                )
              ) : (
                <WaitIcon style={{ fontSize: "2.7rem" }} />
              ),
          },
        ]}
      />
      <Select
        variant="borderless"
        defaultValue="vi"
        getPopupContainer={() => document.body}
        value={i18n.language}
        style={{ flex: "0 0 15rem", minWidth: "15rem", marginLeft:"3rem", width: "15rem" }}
        options={[
          {
            label: (
              <Link href={`${pathname.replace("/en", "/vi")}`}>
                <Row gutter={[5, 5]} wrap={false} align="middle">
                  <Col>
                    <Row align="middle">
                      <VietnamIcon />
                    </Row>
                  </Col>
                  <Col>
                    <Row align="middle">
                      <Text>VI | VND</Text>
                    </Row>
                  </Col>
                </Row>
              </Link>
            ),
            value: "vi",
          },
          {
            label: (
              <Link href={`${pathname.replace("/en", "/vi")}`}>
                <Row gutter={[5, 5]} wrap={false} align="middle">
                  <Col>
                    <Row align="middle">
                      <img
                        width={22}
                        height={22}
                        style={{ width: "2.2rem", height: "2.2rem" }}
                        alt="american-flag-icon"
                        src="/static/images/american-flag-icon.png"
                      />
                    </Row>
                  </Col>
                  <Col>
                    <Row align="middle">
                      <Text>EN | USD</Text>
                    </Row>
                  </Col>
                </Row>
              </Link>
            ),
            value: "en",
          },
        ]}
        onChange={async (val) => {
          if (val === "en") {
            try {
              await dispatch(thunks.get_exchange_currency({})).unwrap();
            } catch {
              toast.error(t("common.exchange_currency_failed"));
              return;
            }
          }
          dayjs.locale(val);
          router.push(
            pathname
              .replace("/vi/", `/${val}/`)
              .replace("/en/", `/${val}/`)
              .replace("/vi", `/${val}`)
              .replace("/en", `/${val}`),
          );
          i18n.changeLanguage(val);
        }}
        // onChange={async (val) => {
        //   if (val === "en") {
        //     await dispatch(thunks.get_exchange_currency({})).unwrap()
        //   }
        //   router.push(pathname
        //     .replace("/vi/", `/${val}/`)
        //     .replace("/en/", `/${val}/`)
        //     .replace("/vi", `/${val}`)
        //     .replace("/en", `/${val}`)
        //   )
        // }}
      />
    </Row>
  );
};

export default BookingProgresses;
